import React from 'react';

import { ErrorResponse, RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { copyToClipboard } from '@eika-infrastruktur/utils';
import { Button } from '@eika/button';
import { ErrorCard as OrgErrorCard } from '@eika/card';
import { IconTypes } from '@eika/icon';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import { errorTrackIds } from '../../utils/gtm/trackIDs/error';

import './ErrorCard.scss';

type ErrorCardProps = import('@eika/card/src/ErrorCard').ErrorCardProps;

function getRcid(exception: RequestExceptionWithResponse | ErrorResponse) {
    if ('requestCorrelationId' in exception) {
        return exception.requestCorrelationId?.value;
    }
    if ('rcid' in exception) {
        return exception.rcid;
    }
    return null;
}

const ErrorCard: React.FC<ErrorCardProps & { hideErrorCode?: boolean }> = ({
    children,
    exception,
    hideErrorCode,
    ...props
}) => {
    const {
        featureToggles: { enableStacktrace },
    } = useConfig();
    const translated = useTranslation();
    const exceptionRCID = exception && getRcid(exception);
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <OrgErrorCard exception={enableStacktrace ? exception : undefined} {...props}>
            {children}
            {!enableStacktrace && exceptionRCID && !hideErrorCode && (
                <p>
                    <Button
                        buttonType="negative"
                        onClick={() => copyToClipboard(exceptionRCID)}
                        aria-label={translated.commonErrors.copyRCID}
                        icon={IconTypes.COPY_24}
                        data-track-id={errorTrackIds.copyRCIDOld.id}
                        data-track-linkname={translated.commonErrors.copyRCID}
                    >
                        {translated.errors.rcid} <span>{exceptionRCID}</span>
                    </Button>
                </p>
            )}
        </OrgErrorCard>
    );
};
export default ErrorCard;
